// TODO: rename to pumps
import MaintenanceDashboard from './maintenance-dashboard.container';
import styles from './maintenance-dashboard.styles';
import { withStyles } from '@material-ui/core';
export * from './maintenance-dashboard.container';

export default withStyles(styles())(MaintenanceDashboard);
